import React, { useCallback, useEffect, useRef, useState } from 'react'
import './SingleEditorModePage.css';
import { useEditorAccessRequestHandler, useLiveStateData, useLiveStateSyncUtils, useUserEditorState } from '@veltdev/react';

function SingleEditorModePage() {

    const liveStateSyncElement = useLiveStateSyncUtils();
    const userEditorAccess = useUserEditorState();
    const liveStateData = useLiveStateData();
    const editorAccessRequested = useEditorAccessRequestHandler();

    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (liveStateSyncElement) {
            liveStateSyncElement.enableSingleEditorMode();
        }
    }, [liveStateSyncElement]);

    useEffect(() => {
        if (!userEditorAccess?.isEditor && liveStateData?.singleEditorModeInput) {
            console.log('Live state data received: ', JSON.parse(JSON.stringify(liveStateData)));
            setInputValue(liveStateData?.singleEditorModeInput?.value);
        }
    }, [liveStateData]);

    useEffect(() => {
        if (editorAccessRequested) {
            console.log('Editor access requested: ', editorAccessRequested);
        }
    }, [editorAccessRequested]);

    const useDebounce = (callback: Function, delay: number) => {
        // Use a ref to store the callback
        const callbackRef = useRef(callback);
        useEffect(() => {
            callbackRef.current = callback;
        });
    
        // Use a ref to store the timer id
        const timerRef = useRef<NodeJS.Timeout | null>(null);
    
        return useCallback((...args: any[]) => {
            // Clear the existing timer
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
    
            // Set a new timer
            timerRef.current = setTimeout(() => {
                callbackRef.current(...args);
            }, delay);
        }, [delay]);
    };

    const debouncedOnInput = useDebounce((value: any) => {
        if (userEditorAccess?.isEditor !== false) {
            console.log('Setting live state data: ', value);
            setLiveStateData('singleEditorModeInput', { value });
        }
    }, 100); // 100ms debounce time

    const onInput = (event: React.FormEvent<HTMLInputElement>) => {
        try {
            const value = (event.target as HTMLInputElement).value;
            setInputValue(value);
            debouncedOnInput(value);
        } catch (error) {
            console.warn('Error setting live state data: ', error);
        }
    };

    const setLiveStateData = (liveStateId: string, data: { value: string }) => {
        try {
            liveStateSyncElement?.setLiveStateData(liveStateId, data);
        } catch (error) {
            console.warn('Error setting live state data: ', error);
        }
    }

    return (
        <div className='single-editor-mode-container'>
            <input id='singleEditorModeInput' className='single-editor-mode-input' 
            placeholder='Type here...'
            value={inputValue} 
            onInput={(event) => onInput(event)} />
        </div>
    )
}

export default SingleEditorModePage;